(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bep-product-purchase-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bep-purchase-bar')) {
    customElements.define('bep-purchase-bar', class extends HTMLElement {
      connectedCallback() {
        this.root = document.getElementById(this.dataset.productRoot);
        this.mainButton = this.root?.querySelector('.product-form__submit');
        if (!this.mainButton) return;
        this.buyButton = this.querySelector('[data-bep-bar-buy]');
        this.editButton = this.querySelector('[data-bep-bar-edit]');
        this.price = this.querySelector('[data-bep-bar-price]');
        this.variant = this.querySelector('[data-bep-bar-variant]');
        this.onBuy = () => {
          this.sync();
          if (this.buyButton.disabled) return;
          this.requestedFromBar = true;
          this.mainButton.click();
          this.sync();
        };
        this.onEdit = () => {
          const picker = this.root.querySelector('variant-selects');
          const target = picker || this.mainButton;
          target.scrollIntoView({block:'center',behavior:'instant'});
          (picker?.querySelector('input:checked, select') || this.mainButton).focus({preventScroll:true});
        };
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {this.frame = null;this.sync();});
        };
        this.buyButton.addEventListener('click', this.onBuy);
        this.editButton.addEventListener('click', this.onEdit);
        this.root.addEventListener('change', this.schedule);
        this.observer = new MutationObserver(this.schedule);
        this.observer.observe(this.root, {childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled','class']});
        this.visibilityObserver = new IntersectionObserver(([entry]) => {
          this.hidden = entry.boundingClientRect.bottom >= 0;
        });
        this.visibilityObserver.observe(this.mainButton);
        this.sync();
      }
      setText(element, value) {
        if (element.textContent !== value) element.textContent = value;
      }
      sync() {
        if (!this.mainButton) return;
        const busy = this.mainButton.classList.contains('loading');
        const disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
        this.buyButton.disabled = disabled || busy;
        this.setText(this.buyButton, busy ? this.dataset.adding : this.mainButton.querySelector('span').textContent.trim());
        const priceRoot = this.root.querySelector('[id^="price-"] .price');
        const currentPrice = priceRoot?.querySelector(priceRoot.classList.contains('price--on-sale') ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
        this.setText(this.price, currentPrice?.textContent.trim() || '');
        const variantData = this.root.querySelector('variant-selects [data-selected-variant]');
        try {
          const currentVariant = variantData ? JSON.parse(variantData.textContent) : null;
          if (variantData) this.setText(this.variant, currentVariant?.public_title || '');
        } catch (_) {
          this.buyButton.disabled = true;
        }
        const error = this.root.querySelector('.product-form__error-message-wrapper:not([hidden])');
        if (this.requestedFromBar && error?.textContent.trim()) {
          this.requestedFromBar = false;
          this.mainButton.scrollIntoView({block:'center',behavior:'instant'});
          this.mainButton.focus({preventScroll:true});
        }
        if (this.requestedFromBar && !busy && !disabled) this.requestedFromBar = false;
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.visibilityObserver?.disconnect();
        this.root?.removeEventListener('change',this.schedule);
        this.buyButton?.removeEventListener('click',this.onBuy);
        this.editButton?.removeEventListener('click',this.onEdit);
        if (this.frame) cancelAnimationFrame(this.frame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
